import React, { useState } from 'react';
import { Button, Buttons, CancelButton, ModalCard } from '~/components';

export default function RevalueConfirmation({ rateCards, resolve }) {
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    setIsSaving(true);
    await resolve(true);
  };

  return (
    <ModalCard title="Update Tracked Time" onClose={() => resolve(false)}>
      <ModalCard.Body>
        <p>
          Updating {!rateCards ? 'this rate' : rateCards.length > 1 ? 'these rate cards' : 'this rate card'} will change
          the bill rate and/or labor cost rate on one or more existing time entries. Are you sure?
        </p>
      </ModalCard.Body>

      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={() => resolve(false)}>Cancel</CancelButton>
          <Button isLoading={isSaving} onClick={handleSave} data-testid="revalue_confirm">
            Save
          </Button>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}
